module.exports = __webpack_public_path__ + "static/media/Nguyen_Manh_Hiep.f3d8c99e.jpg";